import React from 'react';

// eslint-disable-next-line react/prop-types
const PostCtaAction = ({ reservationLink }) => (
  <span>
    <span className="u-text-small u-co-grey u-hide-on-mobile">
      If you need to modify or cancel this
      appointment, view&nbsp;
      <a
        className="u-co-grey u-td-underline"
        href={reservationLink}
        target="_blank"
        rel="noopener noreferrer"
      >reservation</a>.
    </span>
    <span className="u-text-small u-co-grey u-hide-on-desktop">
      If you need to modify or cancel this<br />
      appointment, view&nbsp;
      <a
        className="u-co-grey u-td-underline"
        href={reservationLink}
        target="_blank"
        rel="noopener noreferrer"
      >reservation</a>.
    </span>
  </span>
);

export default PostCtaAction;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/PostCtaAction.jsx